import Vue from 'vue'
import Vuex from 'vuex'

import modals from './modules/modals'
import recommendations from './modules/recommendations'
import general from './modules/general'
import admins from './modules/admin_list'
import tags from './modules/tag_list'
import feedDesignators from './modules/feed_designators'
import skills from './modules/skill_list'
import jobTitles from './modules/job_titles'
import settings from './modules/setting_list'
import offerStatuses from './modules/offer_statuses_list'
import sendCvMode from './modules/sendCvMode'
import aiEvaluation from './modules/aiEvaluation'
import feedPrefetch from './modules/feedPrefetch'
import positionRecommendations from './modules/positionRecommendations'
import recordingMonitor from './modules/recordingMonitor'
import offerConversations from './modules/offerConversations'
import cvTextArtifacts from './modules/cvTextArtifacts'
import recruiterQa from './modules/recruiterQa'
import recruiterQaAdmin from './modules/recruiterQaAdmin'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    modals,
    general,
    recommendations,
    admins,
    tags,
    feedDesignators,
    skills,
    settings,
    offerStatuses,
    jobTitles,
    sendCvMode,
    aiEvaluation,
    feedPrefetch,
    positionRecommendations,
    recordingMonitor,
    offerConversations,
    cvTextArtifacts,
    recruiterQa,
    recruiterQaAdmin
  }
})

export default store

export const initializeStore = async () => {
  await store.dispatch('admins/fetchAll')
  await store.dispatch('settings/fetchSettings')
  await store.dispatch('feedDesignators/fetchFeedDesignators')
  await store.dispatch('offerStatuses/fetchOfferStatuses')
  await store.dispatch('skills/fetchAllSkills')
  await store.dispatch('jobTitles/fetchAllJobTitles')
}
